import type { routes } from '@semios/app-platform-banyan-route-definitions'
import type { Contact, Group } from '../../../ContactsAndGroups/ContactsAndGroupsContext'
import type { Report } from '../../_types'

const convertStartEndAPIToLocal = (modelStartEnd: { startDate: string; endDate: string } | null) =>
  !modelStartEnd ? null : modelStartEnd

export const convertAPIWeeklyGeneralReportToLocalFormat = (
  newReportRaw: NonNullable<
    routes.LegacyWeeklyGeneralReportsManagement.Response['data']['legacyWeeklyGeneralReportsToCreate']
  >[number],
  groupsFromState: Group[],
  contactsFromState: Contact[],
): NonNullable<NonNullable<Report>['weeklyGeneral']>[number] => {
  return {
    id: newReportRaw?.reportId ? String(newReportRaw.reportId) : null,
    name: newReportRaw.name,
    contacts: Object.values(newReportRaw?.contacts ?? {}).flatMap((c) => {
      const foundCorrespondingContact = contactsFromState.find((cfs) => cfs.id === c.contactId)

      if (!foundCorrespondingContact) return []

      return {
        alertsContactMethods: foundCorrespondingContact.alertsContactMethods,
        email: c.email,
        sms: c.sms,
        groups: foundCorrespondingContact.groups,
        id: c.contactId,
        language: foundCorrespondingContact.language,
        name: c.name,
        reportsContactMethods: foundCorrespondingContact.reportsContactMethods,
      }
    }),
    groups: Object.values(newReportRaw?.groups ?? {}).flatMap((g) => {
      const foundCorrespondingGroup = groupsFromState.find((cfs) => cfs.id === g.groupId)

      if (!foundCorrespondingGroup) return []

      return {
        contacts: foundCorrespondingGroup.contacts,
        id: g.groupId,
        name: g.name,
        alertsContactMethods: foundCorrespondingGroup.alertsContactMethods,
        reportsContactMethods: foundCorrespondingGroup.reportsContactMethods,
      }
    }),
    notifyOwnerByEmail: newReportRaw.notifyOwnerByEmail,
    rules: {
      dayOfWeek: newReportRaw.dayOfWeek,
      properties: newReportRaw.propertyIds?.map((propertyId) => ({ id: String(propertyId) })) ?? [],
      chill: convertStartEndAPIToLocal(newReportRaw.chill),
      evapotranspiration: convertStartEndAPIToLocal(newReportRaw.evapotranspiration),
      fireBlight: convertStartEndAPIToLocal(newReportRaw.fireBlight),
      growingDegreeDays: convertStartEndAPIToLocal(newReportRaw.growingDegreeDays),
      irrigationActivity: convertStartEndAPIToLocal(newReportRaw.irrigationActivity),
      pollination: convertStartEndAPIToLocal(newReportRaw.pollination),
      soilMoisture: convertStartEndAPIToLocal(newReportRaw.soilMoisture),
      weather: convertStartEndAPIToLocal(newReportRaw.weather),
      pests: newReportRaw.insects
        ? Object.values(newReportRaw.insects).map((insect) => ({
            degreeDays: insect.degreeDays,
            trapCatches: insect.trapCatches,
            id: String(insect.insectId),
            startDate: insect.startDate,
            endDate: insect.endDate,
          }))
        : [],
      irrigationPlanner: { startDate: null, endDate: null },
      scout: { startDate: null, endDate: null },
    },
  }
}
